<template>

  <div v-if="details">
  <div v-if="!settings || settings && settings.hideHeader !== false" style="padding: 7px 12px;" v-bind:style="{'background': colors.accent_color, 'color': colors.accent_color2}"><a href="#" v-bind:style="{'color': colors.accent_color2}" @click.prevent="function(){ onClose() }" class="hit-pull-right" style="text-decoration: none; font-size: 2em;" v-if="!settings || settings && settings.hideCloseBtn === false">X</a><span v-if="surveyName">{{ $tc("message.board") }} <b>{{ surveyName }}</b><br /></span>{{ $tc("message.feedback", 1) }} <b>{{ details.name }}</b>

    <div class="hit-clearfix" /></div>
  <div v-bind:style="{
    'background': colors.background_color,
    'color': colors.text_color,

    }">

    <div class="hit-list-group">

      <div class="hit-list-group-item hit-text-center" v-bind:style="{
        'background': colors.background_color,
        'color': colors.text_color,
        'border': '1px solid '+colors.accent_color
        }">
        <h2 class="hit-html-h2" style="margin-bottom: 0.1em;" v-bind:style="{
          'color': colors.text_color,
          }">{{ details.name }}</h2>
        <hit_stars class="hit-text-warning hit-html-h1" :animate="true" :stars="details.average" v-bind:style="{
          'color': colors.accent_color

          }"/>
      </div>
    <div class="hit-list-group-item " v-for="(detail, index) in details.stars" v-bind:style="{
      'background': colors.background_color,
      'color': colors.text_color,
      'border': '1px solid '+colors.accent_color
      }">
      <div class="hit-form-group">

          <span v-for="(star, question) in detail">
            <h4 class="hit-html-h4">{{ question }}</h4>
            <hit_stars class="hit-text-warning" :stars="star"  v-bind:style="{
              'color': colors.accent_color

              }"/>

            <div v-if="details.description[index][question]">
              <hr class="hit-html-hr" style="margin: 5px 0;">
              {{ details.description[index][question] }}
            </div>
          </span>


      </div>
    </div>

    <div class="hit-list-group-item hit-active" v-if="details.adminComment" v-bind:style="{
      'background': colors.accent_color,
      'color': colors.accent_color2,
      'border': '1px solid '+colors.accent_color
      }">
      <p>
      <hit_icon :id='"comments"' />&nbsp;<b>{{ details.board.user.username }}</b>: <span v-html="details.adminComment" />
      </p>
    </div>
  </div>

  </div>

  </div>

</template>

<script>

  export default{

    props: { details: Object, surveyName: String, colors: Object, onClose: Function, settings: Object }

  }

</script>
